import { render, staticRenderFns } from "./trash.vue?vue&type=template&id=07d5867e&"
import script from "./trash.vue?vue&type=script&lang=js&"
export * from "./trash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\xampp\\htdocs\\app.poojalab.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07d5867e')) {
      api.createRecord('07d5867e', component.options)
    } else {
      api.reload('07d5867e', component.options)
    }
    module.hot.accept("./trash.vue?vue&type=template&id=07d5867e&", function () {
      api.rerender('07d5867e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/message/trash.vue"
export default component.exports